import { Environment } from './environment.class';

export const environment: Environment = {
  production: true,
  mockDomaine: 'http://localhost:3000/devflix/api',
  baseUrlSpa: '',
  creditEndpoint: 'adresse-client/credit',
  creditFiservEndpoint: 'coordonnees/credit',
  bancaireEndpoint: 'coordonnees/bancaire',
  mock: false,
  keyPosteCanada: 'bb86-ga49-un89-pw85',
  spinnerTimeout: 90000,
};
